import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
const React = require("react");
import { any, async, fromJSX, loadedAsyncState, loadingAsyncState, nothing, stateful } from "widgets-for-react";
import { allLocationsId, availabilityOptionLabels, fetchCollectionItemById, mediaLabel } from "../../../backendApi/CollectionApi";
import { config } from "../../../config";
import { hasValue } from "../../../utils/asyncState";
import { protocolAndHost } from "../../../utils/browser";
import { noOp } from "../../../utils/functions";
import { ResponsivePicture, singleCrop } from "../../Image";
import { Link } from "../../Link";
import { Text } from "../../Text";
import { pushCollectionAction, titleAndAuthor } from "../CollectionUtils";
export const CollectionSearchResult = (props)=>CollectionSearchResultWidget({
        id: props.item.Id,
        item: props.item.MoreDataAvailable ? loadingAsyncState(fetchCollectionItemById(props.item.Id), props.item) : loadedAsyncState(props.item),
        itemFallback: props.item,
        config: props.config,
        selectedBranch: props.selectedBranch
    }).run(noOp);
export const CollectionSearchResultWidget = stateful()((props)=>any({
        key: `CollectionSearchResult-${props.id}-${props.selectedBranch}`
    })([
        // Render the CollectionItem as Search Result
        fromJSX((_)=>hasValue(props.item) ? CollectionSearchResultLayout({
                ...props,
                item: props.item.value
            }) : props.item.kind == "failed" ? CollectionSearchResultLayout({
                ...props,
                item: props.itemFallback
            }) : /*#__PURE__*/ _jsx(_Fragment, {})),
        // Manage async state updates
        async(nothing, {
            key: `CollectionSearchResultLoader-${props.id}`
        })(props.item).map((itemUpdater)=>(s0)=>({
                    ...s0,
                    item: itemUpdater(s0.item)
                }))
    ]).map((a)=>a(props)));
export const CollectionSearchResultLayout = (props)=>{
    const { item, selectedBranch } = props;
    const { mainTitle, title, authors, shortDescription, Id, image, medium, derivedAvailabilityStatus, availableAtBranchIds } = item;
    const author = authors && authors.length > 0 ? authors[0] : undefined;
    const url = `${props.config.route}/${Id}`;
    const { arrowIconId } = config().ui;
    const availability = derivedAvailabilityStatus === 'onRequest' ? 'onRequest' : derivedAvailabilityStatus === 'notAvailable' ? 'onLoan' : selectedBranch === allLocationsId ? 'availableAnywhere' : availableAtBranchIds.includes(selectedBranch) ? 'availableHere' : 'availableElsewhere';
    return /*#__PURE__*/ _jsx("li", {
        className: "c-item",
        children: /*#__PURE__*/ _jsxs(Link, {
            className: "c-item__link",
            url,
            handle: ()=>pushCollectionAction()("Volg zoekresultaat", titleAndAuthor(props.item)),
            children: [
                /*#__PURE__*/ _jsxs("div", {
                    className: "c-item__content--wrapper",
                    children: [
                        /*#__PURE__*/ _jsxs("div", {
                            className: "c-item__labels c-item__content",
                            children: [
                                /*#__PURE__*/ _jsx("div", {
                                    className: "c-item__medium c-item__label text--s",
                                    children: mediaLabel[medium]
                                }),
                                /*#__PURE__*/ _jsxs("div", {
                                    className: `c-item__availability text--s c-item__availability--${availability}`,
                                    children: [
                                        /*#__PURE__*/ _jsx("div", {
                                            className: "c-item__availability--dot"
                                        }),
                                        /*#__PURE__*/ _jsx("span", {
                                            className: "c-item__availability--label",
                                            children: availabilityOptionLabels[availability]
                                        })
                                    ]
                                })
                            ]
                        }),
                        /*#__PURE__*/ _jsxs("div", {
                            className: "c-item__content",
                            children: [
                                /*#__PURE__*/ _jsxs("div", {
                                    className: "c-item__text",
                                    children: [
                                        /*#__PURE__*/ _jsx("h4", {
                                            className: "c-item__title title--s",
                                            children: /*#__PURE__*/ _jsx("span", {
                                                children: mainTitle || title
                                            })
                                        }),
                                        author && /*#__PURE__*/ _jsx("div", {
                                            className: "c-item__author text--m",
                                            children: author
                                        }),
                                        shortDescription && /*#__PURE__*/ _jsx(Text, {
                                            className: 'c-item__intro text--m',
                                            MarkUp: "plaintext",
                                            Content: shortDescription
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ _jsx("svg", {
                                    className: "c-item__icon",
                                    width: "2.4rem",
                                    height: "2.4rem",
                                    "aria-hidden": "true",
                                    children: /*#__PURE__*/ _jsx("use", {
                                        xlinkHref: arrowIconId
                                    })
                                })
                            ]
                        })
                    ]
                }),
                /*#__PURE__*/ _jsx("div", {
                    className: "c-item__visual",
                    children: image ? /*#__PURE__*/ _jsx(ResponsivePicture, {
                        defaultImageUrl: image.Thumbnail,
                        imgClassName: "c-item__image",
                        cropsPerMedia: [
                            {
                                crops: [
                                    {
                                        url: image.Thumbnail,
                                        width: 240
                                    },
                                    {
                                        url: image.Thumbnail2x,
                                        width: 480
                                    }
                                ]
                            }
                        ],
                        width: 240
                    }) : /*#__PURE__*/ _jsx(ImageFallback, {
                        ...props.config
                    })
                })
            ]
        })
    }, `CollectionSearchResult-${Id}`);
};
const ImageFallback = (props)=>{
    const url = protocolAndHost() + props.coverFallbackImageUrl;
    return /*#__PURE__*/ _jsx(ResponsivePicture, {
        defaultImageUrl: url,
        imgClassName: "c-item__image c-item__image--empty",
        cropsPerMedia: singleCrop(url)
    });
};
